export type WhatsAppSetupIntent = "idle" | "signup" | "phone";

/**
 * Presentation signal only. True while Embedded Signup is open or a signup /
 * phone-selection request the page already started is still in flight.
 * Does not invent a connected account.
 */
export function shouldShowWhatsAppConnecting(input: {
  setupIntent: WhatsAppSetupIntent;
  metaLaunching: boolean;
  busy: boolean;
}): boolean {
  if (input.metaLaunching) return true;
  return input.setupIntent !== "idle" && input.busy;
}

/**
 * The detail skeleton is only the initial connection load.
 * A signup failure stays mounted; connecting already has its own panel.
 */
export type PendingWhatsAppRegistrationMode = "complete" | "cancel-only";

/** Complete Registration is available only when a stored snapshot names one phone. */
export function pendingWhatsAppRegistrationMode(input: {
  externalPhoneNumberId: string | null | undefined;
  resumeBlocked: boolean;
}): PendingWhatsAppRegistrationMode {
  if (input.resumeBlocked || !input.externalPhoneNumberId) {
    return "cancel-only";
  }
  return "complete";
}

export function shouldShowWhatsAppPageSkeleton(input: {
  connecting: boolean;
  viewKind: "loading" | "unavailable" | "ready" | "pending-selection" | "error";
}): boolean {
  if (input.connecting) return false;
  if (input.viewKind === "error" || input.viewKind === "unavailable") return false;
  return input.viewKind === "loading";
}
